(function ($) {
  DJ.addBehavior('manageRolesFocus', '.node-project-idea-manage-project-roles-form', {
    attach: function () {
      const rolesForm = this;

      /**
       * If no form - return false.
       */
      if (!rolesForm) {
        return false;
      }

      /**
       * On ajax complete put focus on the needed element.
       */
      $(document).ajaxComplete(() => {
        if (rolesForm) {
          const textField = rolesForm.querySelector('.js-text-full');
          const buttonModify = rolesForm.querySelectorAll('.button--modify');
          const buttonRemoveConfirm = rolesForm.querySelector('.ief-form-row [value="Retirer"]');

          switch (true) {
            case !!textField:
              textField.focus();
              break;
            case !!buttonRemoveConfirm:
              buttonRemoveConfirm.focus();
              break;
            case !!buttonModify.length:
              buttonModify[buttonModify.length - 1].focus();
              break;
            default:
          }
        }
      });

      return true;
    }
  });
})(jQuery);
